import type { SchemaWithSlotLayout } from '@cli-types/core-engine/schema-reader.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isSchemaSlotLayout } from './is-schema-slot-layout.js'
import { normalizeFields } from './normalize-fields.js'
import { normalizeSlotLayoutFields } from './normalize-slot-layout-fields.js'

export function normalizeSchemaFields(input: SchemaWithSlotLayout): SchemaField[] {
  if (isSchemaSlotLayout(input.slot)) return normalizeSlotLayoutFields(input.slot)
  return normalizeFields(input.fields ?? [])
}
